import { useOpenVerify } from '@pages/personal/client/editor-page/model.ts';

export const useOpenEmailVerify = () => {
  const { doOpenVerificationModal, doCloseVerificationModal, state } =
    useOpenVerify('emailVerifyModalState');
  return {
    openEmailVerificationModal: doOpenVerificationModal,
    closeEmailVerificationModal: doCloseVerificationModal,
    state,
  };
};
